import { conversionFuncs } from '@hooks/useFilters';
import { IFilters } from '@pages/offers/interfaces';

export const DEFAULT_FILTERS = {
    search: '',
    trafficSources: [],
    allowedCountries: [],
    compilationIds: [],
    categoriesIds: [],
    hasBonusProgram: false,
    suitablePlacements: false,
    myPrograms: false,
    labelIds: false,
    hasFeed: false,
    typeId: '1,2,6,7',
    order: 'webmasterPriority',
} as IFilters;

export const DEFAULT_UNIQ_PLACEMENTS_PARAMS = {
    statuses: 'review,waiting,allow,ban,recheck' as string,
    fields: 'title,url,hash,trafficSourceId,connections',
    limit: 50,
} as {
    statuses: string;
    fields: string;
    limit: number;
    hash?: string;
};

export const OFFERS_COMPILATIONS_PARAMS = {
    viewRules: 'role_user',
    status: 'active',
    limit: 30,
    offset: 0,
};

export const OFFERS_PARAMS = {
    limit: 15,
    viewRules: 'role_user',
    fields:
        'id,url,rating,labelIds,image,name,webmasterMaxRate,webmasterRateSymbol,confirm,cr,webmasterConfirmTimeInDays',
};

export const EXPORT_FORMATS = [
    {
        label: 'csv',
        value: 'csv',
    },
    {
        label: 'xls',
        value: 'xls',
    },
    {
        label: 'xlsx',
        value: 'xlsx',
    },
];

export const FILTERS_CONVERSION_FUNCS = {
    trafficSources: conversionFuncs.array,
    compilationIds: conversionFuncs.array,
    categoriesIds: conversionFuncs.array,
    allowedCountries: conversionFuncs.array,
    suitablePlacements: conversionFuncs.boolean,
    hasBonusProgram: conversionFuncs.boolean,
    labelIds: conversionFuncs.boolean,
    isExclusive: conversionFuncs.boolean,
    hasFeed: conversionFuncs.boolean,
    typeId: conversionFuncs.string,
    order: conversionFuncs.string,
};
